namespace TabAurous {
    export interface ExportExcelRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Stock.StockItemRow[];
        PurchaseItems?: TabAurous.Purchase.PurchaseItemsRow[];
        values?: string[];
        orderDetailsRows?: TabAurous.OMS.SubCategoryMasterRow[];
        PriceBifurcationItems?: TabAurous.Reports.PriceBifurcationRow[];
        ledgerRows?: TabAurous.OMS.LedgerPostingRow[];
        withBOM?: boolean;
    }
}
